const INITIAL_STATE = {
    showWIPStatus: { values: [], error: null, loading: false },
  };
  
  export default function (state = INITIAL_STATE, action) {
    return {
      ...state,
      showWIPStatus: { values: action.payload, error: null, loading: true },
    };
  }
  